const ModalDataTypes = Object.freeze({
  PAGES: 'pages',
  BLOG_POSTS: 'blog',
  BLOG_LISTING_PAGES: 'blogListingPages',
  FOLDERS: 'folders',
  TAGS: 'tags',
  AUTHORS: 'authors'
});
export default ModalDataTypes;